import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { getDetailTypeSchedule, editTypeSchedule, deleteTypeSchedule } from 'api/company';
//components
import Title from 'components/backoffice/texts/title';
import TypeScheduleForm from 'components/backoffice/forms/typeScheduleForm';

const EditTypeSchedules = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const [typeSchedule, setTypeSchedule] = useState({})
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()


  useEffect(() => {
    const detailTypeSchedule = async () => {
      try {
        const { data, status } = await getDetailTypeSchedule(id);
        if (status === 200) {
          setTypeSchedule(data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    detailTypeSchedule();
  }, []);

  useEffect(() => {
    if (typeSchedule) {
      setTitle(t('edit', { title: typeSchedule?.name }))
    }
    return () => {
      setTitle('');
    };
  }, [typeSchedule, setTitle])

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    const formData = new FormData()
    formData.append('name', values.name)
    formData.append('icon', values?.icon instanceof File ? values?.icon : typeSchedule.icon)
    try {
      const response = await editTypeSchedule(formData, id);
      const { status, data: responseData } = response;
      if (responseData?.name?.[0] === "The type of schedule provided is already registered") {
        toast.error(t('typeScheduleAlreadyExists'), { theme: 'colored' });
        setLoading(false);
        return;
      }
      if (status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/type-schedules', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }, []);

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteTypeSchedule(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/type-schedules', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);


  return (
    <div>
      <Title text={t('edittypeschedule')} />
      <TypeScheduleForm
        isEditing={true}
        onSubmitForm={onSubmit}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        defaultValues={typeSchedule}
        onDelete={handleDelete}
        id={id}
      />
    </div>
  );
};

export default EditTypeSchedules